/**
 *  Date    : 2017/8/3
 *  Author  : Weilin
 *  Declare : 生成唯一id
 */

import uuid from '@wtdc/shortid';

export default uuid;
